import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-white px-4 pb-4 pt-4" data-id="element-73" data-mp="9kjvumdkz02m">
      <div className="mx-auto max-w-3xl text-center" data-id="element-74" data-mp="9lbfcytwl7cj">
        <h1 className="mb-2 font-display text-[19px] font-extrabold uppercase leading-tight text-brand-ink sm:text-4xl" data-id="element-75" data-mp="4m8msdv40tlg">
          Le système complet pour apprendre, concevoir et maîtriser la domotique
        </h1>
        <p className="mx-auto mb-1 max-w-2xl text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-76" data-mp="xa4ef45tnvbd">
          Arrêtez de perdre des heures entre vidéos, tutoriels, forums et informations dispersées
          pour essayer de comprendre comment créer une maison connectée qui fonctionne vraiment.
        </p>
        <p className="mx-auto mb-2 max-w-2xl text-[13px] font-semibold leading-snug text-brand-ink sm:text-base" data-id="element-77" data-mp="3d33gb2q0p1mv">
          Enfin, tout ce dont vous avez besoin est organisé dans un système pratique et progressif.
        </p>

        <a href={OFFER_ANCHOR} className="mb-2 block" aria-label="Aller à la section d’achat" data-id="element-78" data-mp="3j6g1bysfzti2">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[300px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-sm" data-id="element-79" data-mp="3o5j2v997rhla" />
        </a>

        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-80" data-mp="30gzw4y5tbcvb">🚀 OUI ! JE VEUX MON SYSTÈME MAINTENANT</CTAButton>

        <TrustRow zeroRisk data-id="element-81" data-mp="359sxrd5zi536" />
      </div>
    </section>;
}